import { EditorialBodyCopy } from '@cbhq/cdx-components';
import { jsx } from 'react/jsx-runtime';
const EDITORIAL_BODY_ARTICLE_CONTENT_MODEL_ID = 'cdxEditorialBodyArticle';
function EditorialBodyArticle({
  title,
  subtitle,
  style,
  anchor,
  hasSpacingTop
}) {
  return /*#__PURE__*/jsx(EditorialBodyCopy, {
    title: title,
    text: subtitle,
    style: style,
    anchor: anchor,
    hasSpacingTop: hasSpacingTop
  });
}
export { EDITORIAL_BODY_ARTICLE_CONTENT_MODEL_ID, EditorialBodyArticle };
//# sourceMappingURL=EditorialBodyArticle.js.map
